import { Box, Stack, Typography } from '@mui/material';
import { ReasonOrEntityLabelType } from 'v2/core/entities/feedback/labels';

interface AddPredictionToastProps {
  prediction?: ReasonOrEntityLabelType;
  hasAddedReasonCandidate?: boolean;
  selectedReasonRC: string;
}

export const AddPredictionToast = ({
  prediction,
  hasAddedReasonCandidate,
  selectedReasonRC,
}: AddPredictionToastProps) => {
  return (
    <Stack spacing={1} mt={-0.5}>
      <Typography variant="subtitle1">Thanks for the edit!</Typography>
      {prediction?.type === 'REASON' && hasAddedReasonCandidate ? (
        <Box component="p">
          <Typography component="span" variant="body2">
            We'll use it to level up Enterpret's analytics{' '}
            <Typography component="span" variant="body2" color="text.primary">
              "{selectedReasonRC}"
            </Typography>{' '}
            will be predicted in all past and future records in association with{' '}
            <Typography component="span" variant="body2" color="text.secondary">
              {prediction?.displayName}
            </Typography>
            <Typography variant="body2">
              This change may take up to 60 mins to reflect on your
              organization's Taxonomy.
            </Typography>
          </Typography>
        </Box>
      ) : (
        <Box component="p">
          <Typography variant="body2">
            We'll use it to better categorize your customer feedback.
          </Typography>
          <Typography variant="body2">
            This change may take up to 60 mins to reflect on your organization's
            Taxonomy.
          </Typography>
        </Box>
      )}
    </Stack>
  );
};
